import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import MasterImportComponent from "./MasterImport";

import { hospitalServicesLookupFromMaster, resetPage, set } from '../../../store/actions/pages';
import { BooleanDropdownValues, BooleanEquators, dateEquators, integerEquators, StringEquators } from '../../../store/constants/pages';
import { createDateField, createIconDataField, createNumberDataField, createStringDataField } from '../../../util/format';

import { setV2 } from '../../../store/actions/pagesV2';
import { getByName, reset } from '../../../store/actions/search';
import { selectSessionRole } from '../../../store/selectors/session';
import { setHopsitalServicesLookupDialog, setHopsitalServicesLookupImportConfirmationDialog } from "../../../store/actions/hospitalServices";
import { createFilteredSortedDataSelector } from "../../../util/selector";

const DEFAULT_SORT = [{ id: 'code', orderBy: 'asc' }];
const selectLookupDialog = (state) => state.hospitalServices.lookupDialog;
export const selectFacilityList = (state) => state.facilities.data;

const selectCodeType = createSelector(
    selectLookupDialog,
    (lookupHsDialog) => {
        if (lookupHsDialog && lookupHsDialog?.codeType) {
            return lookupHsDialog?.codeType;
        }
        return null;
    }
);

const selectFields = createSelector(
    selectCodeType,
    selectFacilityList,
    (codeType, facilities) => {
        const isDRG = codeType === 'DRG';
        const isHIPPS = codeType === 'HIPPS';

        return [
            createStringDataField('code', 'Code', { sortable: true, equators: StringEquators, whiteSpace: 'break-spaces' }),
            createStringDataField('type', 'Type', { sortable: true, equators: StringEquators, whiteSpace: 'break-spaces', hideFromFilter: (!isDRG && !isHIPPS), hideFromGrid: (!isDRG && !isHIPPS) }),
            createStringDataField('title', 'Description', { sortable: true, equators: StringEquators, whiteSpace: 'break-spaces' }),
            createNumberDataField('weights', 'Weight', { sortable: true, equators: integerEquators, hideFromFilter: !isDRG, hideFromGrid: !isDRG }),
            createDateField('effectiveFrom', 'Effective From', { sortable: true, equators: dateEquators, hideFromFilter: isDRG, hideFromGrid: isDRG }),
            createIconDataField('isEffective', 'Effective', { hideFromFilter: true, icon: 'fas fa-check-circle', sortable: true }),
            createIconDataField('isDiscontinued', 'Discontinued', { equators: BooleanEquators, hideFromFilter: false, icon: "fas fa-times-circle", checkedClass: 'text-danger', sortable: true, isStrictDropdown: true, dropdownValues: BooleanDropdownValues }),
        ];
    }
);

const selectData = createSelector(
    (state) => state.pages['hospitalservices-master-landing'].list,
    (data: any) => {
        return data.map(hospitalService => ({
            ...hospitalService,
            disabledCheckbox: hospitalService?.isDiscontinued || !hospitalService?.isEffective
        }));
    }
);

const selectFilteredFields = createSelector(
    selectFields,
    (fields) => {
        return fields.map(field => field.id);
    }
);

const selectOpen = createSelector(
    selectLookupDialog,
    (lookupHsDialog) => {
        if (lookupHsDialog && lookupHsDialog?.open) {
            return true
        }
        return false
    }
);

export const MasterImport = connect(
    () => {
        return (state:any, props) => ({
            lookupDialogOpen: selectOpen(state),
            hospitalServicesMasterData: selectData(state),
            hospitalServicesMasterFields: selectFields(state as never),
            userRole: selectSessionRole(state as never),
            order: state.pages[`hospitalservices-master-landing`].order,
            filter: state.pages[`hospitalservices-master-landing`].filter,
            sort: state.pages[`hospitalservices-master-landing`].sort,
            codeType: selectCodeType(state),
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            hospitalServicesLookupFromMaster: hospitalServicesLookupFromMaster,
            searchGetByName: getByName,
            searchReset: reset,
            resetPagedTable: resetPage,
            setList: (value) => set('hospitalservices-master-landing', 'list', value),
            setSelectedItems: (value) => setV2('hospitalservices-master-landing', 'selected', value),
            setHopsitalServicesLookupDialog: setHopsitalServicesLookupDialog,
            setHopsitalServicesLookupImportConfirmationDialog: setHopsitalServicesLookupImportConfirmationDialog
        }, dispatch)
    })
)(injectIntl(MasterImportComponent));